import { Configuration } from "@azure/msal-browser";
import { IStringDictionary } from "../common/sharedTypes";

const addAppIds: IStringDictionary = {
  prod: "86114305-6105-4263-b2a0-ebba19c04d89",
  ppe: "f17081de-2c12-4f01-b507-626f456ce02b",
  dev: "0c7c95a9-b1e2-4725-9a25-793e4205739d",
  local: "5bde47ae-9ed7-4c19-ab07-eb5d9f23b1f3",
};

export const msalConfig: Configuration = {
  auth: {
    clientId: addAppIds[process.env.APP_ENV || "dev"],
    authority: "https://login.microsoftonline.com/microsoft.onmicrosoft.com",
    redirectUri: "/",
    postLogoutRedirectUri: "/",
  },
  cache: {
    cacheLocation: "localStorage",
  },
};
